export default __webpack_public_path__ + "static/media/pin-mode-marker.1cd28014.svg";